import Editor from "@monaco-editor/react";

export default function JsonPanel({ toolData, setToolData }) {
	return (
		<div>
			<label className="block text-sm font-semibold text-gray-800 dark:text-white mb-1">JSON Data</label>
			<p className="text-xs text-gray-500 mb-2">Enter the JSON payload that this tool returns.</p>
			<div className="border border-gray-300 rounded-lg overflow-hidden">
				<Editor
					height="180px"
					defaultLanguage="json"
					value={toolData.json || "{}"}
					theme="vs-dark"
					options={{ minimap: { enabled: false }, fontSize: 13, scrollBeyondLastLine: false }}
					onChange={(value) => setToolData({ ...toolData, json: value })}
				/>
			</div>
		</div>
	);
}
